import Chip from "@mui/material/Chip";
import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

const CustomChip = styled(Chip)(({ theme, ownerState }) => {
  const { palette, functions } = theme;
  const { color } = ownerState;

  const { white, dark, gradients } = palette;
  const { linearGradient } = functions;

  // styles for the badge with variant="gradient"
  const gradientStyles = (colorProp) => {
    const backgroundValue = gradients[colorProp]
      ? linearGradient(gradients[colorProp].main, gradients[colorProp].state)
      : linearGradient(gradients.info.main, gradients.info.state);
    const colorValue = colorProp === "light" ? dark.main : white.main;

    return {
      background: backgroundValue,
      color: colorValue,
    };
  };

  return {
    "&.MuiChip-root": {
      ...gradientStyles(color || "dark"),
    },
  };
});

const HomeworkCategoryLabel = ({ name, color, ...props }) => {
  return <CustomChip {...props} label={name} ownerState={{ color }} color="default" />;
};

HomeworkCategoryLabel.propTypes = {
  name: PropTypes.string,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
};

export default HomeworkCategoryLabel;
